import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import Tooltip from '@mui/material/Tooltip';
import { colors } from '../mui-theme';

const FilterTags = ({ facetFilters, navigationTheme }) => {
    const dispatch = useDispatch();
    const { query } = useSelector((state) => state.quickSearch);

    const selectedFacetGroup = facetFilters.filter((filter) => filter.selectedOptions.length > 0);
    const selectedFacetOption = selectedFacetGroup.reduce((accumulator, group) => {
        if (!group || group.showAsToggle) {
            return accumulator;
        }
        const { options, selectedOptions } = group;
        const groupOptions = options
            .filter((option) => selectedOptions.includes(option.id))
            .map((option) => ({ ...option, group }));
        return [...accumulator, ...groupOptions];
    }, []);
    const showFacetFilters = selectedFacetOption.length > 0;

    const clearFilters = () => {
        const url = window.location.search.split(query && query != '' ? '&' : '?')[0];

        const urlWithoutParameters = window.location.origin + window.location.pathname;
        window.location = urlWithoutParameters + url;
    };

    return (
        showFacetFilters && (
            <div className="selected-filter__list">
                <span className="selected-filter__label">{translate('search.yourfilter')}</span>
                {selectedFacetOption &&
                    selectedFacetOption.map((option, index) => (
                        <Tooltip
                            key={`option-${index}`}
                            title={option.group.label}
                            arrow
                            placement="top"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: colors.colorprimary80,
                                        color: '#fff',
                                        fontSize: '0.875rem',
                                        padding: '8px 12px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: { sx: { color: colors.colorprimary80 } },
                            }}
                        >
                            <div
                                className="selected-filter__tag"
                                key={`option-${index}`}
                            >
                                {option.group.showAsToggle ? option.group.label : option.label}
                                <button
                                    onClick={() => dispatch(searchFacetChange(option.group, option))}
                                    className="selected-filter__tag--remove-button"
                                >
                                    <CancelOutlined />
                                </button>
                            </div>
                        </Tooltip>
                    ))}
                {navigationTheme === 'category' && (
                    <div className="selected-filter">
                        <span className="selected-filter__label">{translate('search.yourfilter')}</span>
                        {selectedFacetOption &&
                            selectedFacetOption.map((option, index) => (
                                <div
                                    className="selected-filter__tag"
                                    key={`option-${index}`}
                                >
                                    {option.label}
                                    <button
                                        onClick={() => dispatch(searchFacetChange(option.group, option))}
                                        className="selected-filter__tag--remove-button"
                                    >
                                        <CancelOutlined />
                                    </button>
                                </div>
                            ))}
                    </div>
                )}
                {showFacetFilters && (
                    <button
                        className="selected-filter__clear"
                        onClick={() => clearFilters()}
                    >
                        {translate('code.search.clearfilters')}
                    </button>
                )}
            </div>
        )
    );
};

export default FilterTags;
